import React from 'react'
import styled from 'styled-components'
import Typography from '../Typography'
import Button from '../Button/Button'
import { theme } from '../../theme'
import NavArrowRightIcon from '../Icons/NavArrowRightIcon'

const NotificationCard = ({ title, timestamp, actions = [], icon, primaryAction }) => {
  return (
    <Card
      role="link"
      tabIndex={0}
      onClick={() => {
        if (primaryAction && typeof primaryAction.onClick === 'function') {
          primaryAction.onClick()
        }
      }}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && primaryAction && typeof primaryAction.onClick === 'function') {
          e.preventDefault()
          primaryAction.onClick()
        }
      }}
    >
      <CardContent>
        <CardIconWrapper>
          {icon}
        </CardIconWrapper>
        <CardMessageBlock>
          {title}
          <Typography $variant="body-3-medium" color={theme.colors.defaultWeak}>{timestamp}</Typography>
        </CardMessageBlock>
      </CardContent>
      {actions.length > 0 && (
        <Actions>
          {actions.map((act, idx) => (
            <Button
              key={idx}
              onClick={(e) => { e.stopPropagation(); if (typeof act.onClick === 'function') act.onClick(e) }}
              $variant={act.variant || 'outline'}
            >
              {act.icon}
              {act.label}
            </Button>
          ))}
        </Actions>
      )}
      <NavArrowRightIcon fill={theme.colors.defaultSubtle} height={20} width={20} />
    </Card>
  )
}

export default NotificationCard

const Card = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  // gap: ${({ theme }) => theme.sizing.xxs};
  padding: ${({ theme }) => theme.sizing.sm};
  padding-right: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.border.defaultSubtle};
  // border-radius: ${({ theme }) => theme.radius.xs};
  background-color: white;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.fill.defaultSubtle};
  }
`

const CardMessageBlock = styled.div`
  display: flex;  
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xxs};
`;

const CardContent = styled.div`
  display: flex;  
  flex-direction: row;
  gap: ${({ theme }) => theme.sizing.xs};
`;

const CardIconWrapper = styled.div`
  width: ${({ theme }) => theme.sizing.md};
  height: ${({ theme }) => theme.sizing.md};
  border-radius: ${({ theme }) => theme.sizing.xs};
  background-color: ${({ theme }) => theme.fill.brandAlphaMain8};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const Actions = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.sizing.xs};
  padding-left: 32px;
`
